import {BasicEntity} from '../../framework/message/BasicEntity';
import {TranslatedEmb} from './TranslatedEmb';

export class Currency extends BasicEntity {
code: string;
label: TranslatedEmb;
symbol: string;
}

